<template>
    <div class="modal-bg" @click.self="$emit('close')">
      <div class="model-modal">
        <button class="close-btn" @click="$emit('close')" aria-label="بستن">
          <i class="fa fa-times"></i>
        </button>
        <h4 class="modal-title">انتخاب مدل هوش مصنوعی</h4>
        <div class="credit-note">
          <i class="fa-solid fa-cookie-bite"></i>
          کوکی‌ها اعتبار شما برای استفاده از مدل‌ها هستند.
        </div>
        <div 
  class="scrollable-component"
>
  <button 
    v-for="group in modelGroups" 
    :key="group.company" 
    class="company-title-button"
    :class="{ active: selectedCompany === group.company }"
    @click="scrollToGroup(group.company)"
  >
    {{ group.company }}
  </button>
</div>
        <div v-for="group in modelGroups" :key="group.company" :id="'group-' + group.company" class="company-group">
          <div class="company-title">{{ group.company }}</div>
          <div class="model-list">
            <div
              v-for="model in group.models"
              :key="model.id + model.name"
              class="model-card"
            >
              <div class="model-card-header">
                <span class="model-header">
                  <span class="model-name">{{ model.name }}</span>
                  <i v-if="model.image" class="fa-solid fa-image model-image-icon" title="پشتیبانی از تصویر"></i>
                </span>
                <span class="credit-badge" title="نیاز به اعتبار">
                  {{ model.cost }} کوکی
                  <i class="fa-solid fa-cookie-bite"></i>
                </span>
              </div>
              <div class="model-desc">{{ model.description }}</div>
              <button
                class="select-btn"
                @click="$emit('select', model)"
              >
                انتخاب
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "ModelSelectModal",
    props: {
      modelGroups: Array,
    },
    data() {
    return {
      selectedCompany: null,
    };
  },
    methods: {
      scrollToGroup(company) {
    this.selectedCompany = company;
    this.$nextTick(() => {
      const target = document.getElementById("group-" + company);
      const container = this.$el.querySelector(".model-modal");

      if (target && container) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    });
  }
}
  };
  </script>
  
  <style scoped>
.scrollable-component {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  white-space: nowrap;
  padding: 10px 5px;
  min-height: 80px;
  align-items: center;
  scrollbar-width: none;
  position: sticky;
  top: -1px;
  background: #181818;
  z-index: 20;
}

.scrollable-component.is-sticky {
  box-shadow: 0 2px 6px rgba(0,0,0,0.4);
}
.scrollable-component::-webkit-scrollbar {
  height: 6px;
}
.scrollable-component::-webkit-scrollbar-thumb {
  background: #6355cc;
  border-radius: 3px;
}
  /* Mobile First */
  .modal-bg {
    position: fixed;
    z-index: 10000;
    top: 0; left: 0; right: 0; bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .model-modal {
    position: relative;
    background: #181818;
    border-radius: 16px;
    box-shadow: 0 8px 32px #000a;
    padding: 0 1.2rem 1.2rem 0.3rem;
  scroll-padding-top: 70px;  /* reserve space for sticky header */
    width: 98vw;
    max-width: 420px;
    max-height: 98vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    animation: modalIn 0.2s;
  }
  @keyframes modalIn {
    from { transform: scale(0.95); opacity: 0; }
    to   { transform: scale(1); opacity: 1; }
  }
  .close-btn {
    position: absolute;
    top: 0.5rem;
    right: 0.7rem;
    background: #232323;
    color: #fff;
    border: none;
    border-radius: 50%;
    width: 2.2rem;
    height: 2.2rem;
    font-size: 1.3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    transition: background 0.2s;
    box-shadow: 0 2px 8px #0003;
  }
  .close-btn:hover, .close-btn:focus {
    background: #fd7691;
    color: #fff;
  }
  .modal-title {
    color: #9184f7;
    font-weight: bold;
    text-align: center;
    margin-bottom: 0.7rem;
    font-size: 1.1rem;
    margin-top: 0.7rem;
  }
  .credit-note {
    color: #fd7691;
    background: #232323;
    border-radius: 8px;
    padding: 0.5rem 0.7rem;
    margin-top: 10px;
    font-size: 0.98rem;
    margin-bottom: 1.1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    justify-content: center;
  }
  .company-group {
    margin-bottom: 1.5rem;
  }
  .company-title-button {
    display: inline-block;   /* so it respects nowrap */
  color: #6355cc;
  font-weight: bold;
  font-size: 1rem;
  border: 1px solid #6355cc;
  border-radius: 20px;
  padding: 10px 20px;
  white-space: nowrap;     /* prevent text wrapping */
  box-sizing: border-box;  /* include padding in width */
  }
  .company-title-button.active {
  background: #6355cc;   /* filled when active */
  color: #fff;           /* white text for contrast */
}
  .company-title {
    color: #6355cc;
    font-weight: bold;
    font-size: 1rem;
    margin-bottom: 0.5rem;
    border-right: 4px solid #6355cc;
    padding-right: 0.5rem;
  }
  .model-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .model-card {
    background: #232323;
    border-radius: 12px;
    box-shadow: 0 2px 8px #0003;
    padding: 1rem 0.7rem 0.8rem 0.7rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    transition: box-shadow 0.2s, transform 0.2s;
    position: relative;
  }
  .model-card:hover, .model-card:focus-within {
    box-shadow: 0 4px 16px #6355cc88;
    transform: translateY(-2px) scale(1.03);
  }
  .model-card-header {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 0.3rem;
  }
  .model-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: bold;
    color: #fff;
    font-size: 1rem;
    order: 1;
  }
  .model-name {
    font-weight: bold;
    font-size: 1.05rem;
  }
  .model-image-icon {
    color: #6355cc;
    font-size: 1.1rem;
  }
  .credit-badge {
    background: #6355cc;
    color: #fff;
    border-radius: 6px;
    padding: 0.2rem 0.7rem 0.2rem 0.5rem;
    font-size: 0.98rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    box-shadow: 0 1px 4px #6355cc33;
    order: 2;
  }
  .model-desc {
    color: #eee;
    font-size: 0.95rem;
    margin-bottom: 0.7rem;
    min-height: 32px;
  }
  .select-btn {
    width: 100%;
    background: linear-gradient(90deg, #6355cc 60%, #fd7691 100%);
    color: #fff;
    font-weight: bold;
    border: none;
    border-radius: 8px;
    padding: 0.6rem 0;
    font-size: 1.05rem;
    margin-top: 0.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    transition: background 0.2s, box-shadow 0.2s;
    box-shadow: 0 2px 8px #6355cc33;
  }
  .select-btn:active {
    background: linear-gradient(90deg, #fd7691 60%, #6355cc 100%);
  }
  @media (min-width: 600px) {
    .model-modal {
      max-width: 600px;
      padding: 2rem 2rem 1.5rem 2rem; /* Symmetrical for desktop */
    }
    .modal-title {
      font-size: 1.3rem;
    }
    .company-title {
      font-size: 1.1rem;
    }
    .model-list {
      flex-direction: row;
      flex-wrap: wrap;
      gap: 1rem;
    }
    .model-card {
      min-width: 180px;
      max-width: 220px;
      flex: 1 1 180px;
    }
  }
  </style>